<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
    <title>Ko</title>
    <path
      d="M11,1c2.76,0,5.262,1.12,7.072,2.927,1.807,1.811,2.927,4.312,2.927,7.072s-1.12,5.262-2.927,7.072c-1.811,1.808-4.312,2.928-7.072,2.928s-5.262-1.12-7.073-2.927c-1.807-1.811-2.927-4.312-2.927-7.073s1.12-5.262,2.927-7.072c1.811-1.807,4.312-2.927,7.073-2.927h0ZM12.955,7.372c.448-.454,1.175-.457,1.625-.004.45.452.452,1.187.004,1.641l-1.964,1.992,1.966,1.994c.444.451.438,1.181-.013,1.631-.451.45-1.177.449-1.62-.002l-1.953-1.98-1.956,1.984c-.448.455-1.175.457-1.625.004-.45-.452-.452-1.187-.004-1.641l1.963-1.992-1.966-1.994c-.444-.451-.438-1.181.013-1.631.451-.45,1.177-.449,1.62.002l1.953,1.98,1.956-1.984h0ZM16.771,5.229c-1.477-1.477-3.517-2.39-5.771-2.39s-4.295.913-5.772,2.39c-1.477,1.477-2.39,3.517-2.39,5.771s.913,4.295,2.39,5.771c1.477,1.477,3.517,2.39,5.772,2.39s4.295-.913,5.771-2.39c1.477-1.477,2.39-3.517,2.39-5.771s-.913-4.295-2.39-5.772h0Z"
      fill="#ff4141"
    />
  </svg>
</template>

<script>
export default {};
</script>
